import { render, staticRenderFns } from "./chart-worktype-doughnut.vue?vue&type=template&id=b47d723a&scoped=true"
import script from "./chart-worktype-doughnut.vue?vue&type=script&lang=js"
export * from "./chart-worktype-doughnut.vue?vue&type=script&lang=js"
import style0 from "./chart-worktype-doughnut.vue?vue&type=style&index=0&id=b47d723a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d723a",
  null
  
)

export default component.exports